var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.209 19.4648L20.3027 16.9336C20.1445 16.8809 19.9863 16.8281 19.7754 16.8281C19.4062 16.8281 19.0371 17.0391 18.8262 17.3027L16.1895 20.5195C12.0762 18.5684 8.80664 15.2988 6.85547 11.1855L10.0723 8.54883C10.3359 8.33789 10.5469 7.96875 10.5469 7.54688C10.5469 7.38867 10.4941 7.23047 10.4414 7.07227L7.91016 1.16602C7.69922 0.691406 7.22461 0.375 6.69727 0.375C6.64453 0.375 6.53906 0.427734 6.43359 0.427734L0.949219 1.69336C0.369141 1.85156 0 2.32617 0 2.90625C0 16.459 10.916 27.375 24.4688 27.375C25.0488 27.375 25.5234 27.0059 25.6816 26.4258L26.9473 20.9414C26.9473 20.8359 26.9473 20.7305 26.9473 20.6777C26.9473 20.1504 26.6309 19.6758 26.209 19.4648Z",
    fill: "#FF7000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconOrange);
export default __webpack_public_path__ + "static/media/phoneIconOrange.af86fdae7cedb20314cbcd1b41586403.svg";
export { ForwardRef as ReactComponent };